import { ReactNode } from "react";
import BigNumber from "bignumber.js";
import { Token } from "@pulsex/sdk";

export interface FarmTableEarnedProps {
  earnings: number;
  pid: number;
}

export interface FarmTableAmountProps {
  amount: number;
}

export interface FarmTableLiquidityProps {
  liquidity: BigNumber;
  updatedAt?: number;
  inactive?: boolean;
}

export interface FarmTableMultiplierProps {
  multiplier: string;
  rewardIncPerSecond?: number;
  farmIncPerSecond?: string;
  totalMultipliers?: string;
}

export interface FarmTableFarmTokenInfoProps {
  label: string;
  pid: number;
  token: Token;
  quoteToken: Token;
  isReady: boolean;
  isStaking?: boolean;
  stakedBalance?: BigNumber;
  children?: ReactNode;
  rewardIncPerSecond?: number;
}

export type ColumnsDefTypes = {
  id: number;
  label: string;
  name: string;
  sortable: boolean;
};

export const MobileColumnSchema: ColumnsDefTypes[] = [
  {
    id: 1,
    name: "farm",
    sortable: true,
    label: "",
  },
  {
    id: 2,
    name: "earned",
    sortable: true,
    label: "Earned",
  },
  {
    id: 3,
    name: "apr",
    sortable: true,
    label: "APR",
  },
  {
    id: 6,
    name: "details",
    sortable: true,
    label: "",
  },
];

export const DesktopColumnSchema: ColumnsDefTypes[] = [
  {
    id: 1,
    name: "farm",
    sortable: true,
    label: "",
  },
  {
    id: 2,
    name: "protocol",
    sortable: false,
    label: "",
  },
  {
    id: 3,
    name: "apr",
    sortable: true,
    label: "APR",
  },
  {
    id: 4,
    name: "liquidity",
    sortable: true,
    label: "Liquidity",
  },
  {
    id: 5,
    name: "earned",
    sortable: true,
    label: "Earned",
  },
  {
    id: 6,
    name: "weight",
    sortable: true,
    label: "",
  },
  {
    id: 7,
    name: "details",
    sortable: true,
    label: "",
  },
];
